import { render, staticRenderFns } from "./bindEquip.vue?vue&type=template&id=5dc7621a&scoped=true"
import script from "./bindEquip.vue?vue&type=script&lang=js"
export * from "./bindEquip.vue?vue&type=script&lang=js"
import style0 from "./bindEquip.vue?vue&type=style&index=0&id=5dc7621a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc7621a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dc7621a')) {
      api.createRecord('5dc7621a', component.options)
    } else {
      api.reload('5dc7621a', component.options)
    }
    module.hot.accept("./bindEquip.vue?vue&type=template&id=5dc7621a&scoped=true", function () {
      api.rerender('5dc7621a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adver/bindEquip.vue"
export default component.exports